import * as React from "react";
const VoiceMailIcon = (props) => (
  <svg
    width={46}
    height={45}
    viewBox="0 0 46 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.333496} width={45} height={45} rx={6} fill="#8b58f1" />
    <g clipPath="url(#clip0_43824_67446)">
      <path
        d="M33.3335 27.6567V31.782C33.3336 32.0774 33.2217 32.3618 33.0204 32.5779C32.819 32.794 32.5431 32.9257 32.2485 32.9463C31.7387 32.9813 31.3222 33 31.0002 33C20.6903 33 12.3335 24.6432 12.3335 14.3333C12.3335 14.0113 12.351 13.5948 12.3872 13.085C12.4078 12.7904 12.5395 12.5145 12.7556 12.3131C12.9717 12.1118 13.2561 11.9999 13.5515 12H17.6768C17.8215 11.9999 17.9611 12.0535 18.0685 12.1505C18.1759 12.2475 18.2434 12.381 18.2578 12.525C18.2847 12.7933 18.3092 13.0068 18.3325 13.169C18.5644 14.7871 19.0395 16.3608 19.7418 17.8368C19.8527 18.0702 19.7803 18.349 19.5703 18.4983L17.0527 20.2973C18.592 23.8842 21.4505 26.7426 25.0373 28.282L26.834 25.769C26.9074 25.6663 27.0146 25.5927 27.1367 25.5609C27.2589 25.5292 27.3883 25.5413 27.5025 25.5952C28.9784 26.2962 30.5517 26.7701 32.1692 27.001C32.3313 27.0243 32.5448 27.05 32.8108 27.0757C32.9546 27.0904 33.0878 27.158 33.1846 27.2653C33.2814 27.3727 33.3348 27.5121 33.3347 27.6567H33.3335Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 14.9355C22 13.8665 22.8665 13 23.9355 13H31.1613C32.2302 13 33.0968 13.8665 33.0968 14.9355V19.0645C33.0968 20.1335 32.2302 21 31.1613 21H23.9355C22.8665 21 22 20.1335 22 19.0645V14.9355ZM23.9355 13.7742C23.2941 13.7742 22.7742 14.2941 22.7742 14.9355V19.0645C22.7742 19.7059 23.2941 20.2258 23.9355 20.2258H31.1613C31.8026 20.2258 32.3226 19.7059 32.3226 19.0645V14.9355C32.3226 14.2941 31.8026 13.7742 31.1613 13.7742H23.9355Z"
        fill="white"
      />
      <path
        d="M23.9355 13.7742C23.2941 13.7742 22.7742 14.2941 22.7742 14.9355V19.0645C22.7742 19.7059 23.2941 20.2258 23.9355 20.2258H31.1613C31.8026 20.2258 32.3226 19.7059 32.3226 19.0645V14.9355C32.3226 14.2941 31.8026 13.7742 31.1613 13.7742H23.9355Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.2258 15.8367C24.7269 15.8367 24.3225 16.2411 24.3225 16.7399C24.3225 17.2388 24.7269 17.6431 25.2258 17.6431C25.7246 17.6431 26.129 17.2388 26.129 16.7399C26.129 16.2411 25.7246 15.8367 25.2258 15.8367ZM23.5483 16.7399C23.5483 15.8135 24.2993 15.0625 25.2258 15.0625C26.1522 15.0625 26.9032 15.8135 26.9032 16.7399C26.9032 17.6663 26.1522 18.4173 25.2258 18.4173C24.2993 18.4173 23.5483 17.6663 23.5483 16.7399Z"
        fill="#8b58f1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.8708 15.8367C29.3719 15.8367 28.9676 16.2411 28.9676 16.7399C28.9676 17.2388 29.3719 17.6431 29.8708 17.6431C30.3696 17.6431 30.774 17.2388 30.774 16.7399C30.774 16.2411 30.3696 15.8367 29.8708 15.8367ZM28.1934 16.7399C28.1934 15.8135 28.9444 15.0625 29.8708 15.0625C30.7972 15.0625 31.5482 15.8135 31.5482 16.7399C31.5482 17.6663 30.7972 18.4173 29.8708 18.4173C28.9444 18.4173 28.1934 17.6663 28.1934 16.7399Z"
        fill="#8b58f1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.8389 18.0316C24.8389 17.8178 25.0122 17.6445 25.226 17.6445H29.8711C30.0849 17.6445 30.2582 17.8178 30.2582 18.0316C30.2582 18.2454 30.0849 18.4187 29.8711 18.4187H25.226C25.0122 18.4187 24.8389 18.2454 24.8389 18.0316Z"
        fill="#8b58f1"
      />
    </g>
    <defs>
      <clipPath id="clip0_43824_67446">
        <rect
          width={28}
          height={28}
          fill="white"
          transform="translate(8.8335 8.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default VoiceMailIcon;
